import script from "./artmisadsSelect.vue?vue&type=script&setup=true&scoped=true&lang=js"
export * from "./artmisadsSelect.vue?vue&type=script&setup=true&scoped=true&lang=js"

import "./artmisadsSelect.vue?vue&type=style&index=0&id=22756a54&lang=less"

const __exports__ = script;

export default __exports__